import { render, staticRenderFns } from "./PropertyHoldDesignRoyalTower2.vue?vue&type=template&id=2a0d7965&scoped=true&"
import script from "./PropertyHoldDesignRoyalTower2.vue?vue&type=script&lang=js&"
export * from "./PropertyHoldDesignRoyalTower2.vue?vue&type=script&lang=js&"
import style0 from "./PropertyHoldDesignRoyalTower2.vue?vue&type=style&index=0&id=2a0d7965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d7965",
  null
  
)

export default component.exports